import { DataStore } from 'aws-amplify'
import { Profile, Post, Content, Media } from '@/models'

import { groupByKey } from '@/utils/array'

export default {
  data () {
    return {
      loading: 0,
      profile: null,
      post: null,
      contents: null,
      media: null
    }
  },
  async created () {
    this.loading++
    try {
      const id = this.$route.params.id
      this.post = await DataStore.query(Post, id)
      this.profile = await DataStore.query(Profile, this.post.profileID)
      this.contents = await DataStore.query(Content, q => q.postID('eq', id))

      this.media = groupByKey(await Promise.all(
        this.contents.map(async (content) => {
          const media = await DataStore.query(Media, q => q.contentID('eq', content.id))
          return media.map(i => Object.assign({ profileID: this.profile.userID }, i))
        })
      ), 'contentID')

      this.loading--
      if (typeof(this.onLoad) === 'function') {
        this.onLoad.call(this)
      }
    } catch (e) {
      this.$router.replace('/')
    }
  },
  methods: {
    mediaFor (contentID) {
      return (this.media && this.media[contentID]) || []
    }
  }
}
